import { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    TextField,
    Checkbox,
    Box
} from '@mui/material';
import ImagePicker from 'components/MDImagePicker';
import MDButton from "components/MDButton";

export default function CreateTennantDialog({
    open,
    tennant,
    onChange,
    onCancel,
    onConfirm,
}) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Criar Empresa</DialogTitle>

            <DialogContent>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                        }}
                    >
                        <TextField
                            fullWidth
                            label="Nome"
                            type="text"
                            variant="outlined"
                            value={tennant?.CompanyName || ''}
                            onChange={(e) => onChange('CompanyName', e.target.value)}
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            fullWidth
                            label="CNPJ"
                            type="text"
                            variant="outlined"
                            value={tennant?.MainTaxId || ''}
                            onChange={(e) => onChange('MainTaxId', e.target.value)}
                        />
                    </Box>
                    <Box
                        sx={{
                            width: 160,
                            flexShrink: 0,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <ImagePicker
                            value={tennant?.Base64Logo}
                            onChange={(base64) => onChange('Base64Logo', base64)}
                            size={140}
                        />
                    </Box>
                </Box>

                <span style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                    Configurações de envio de e-mail:
                </span>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        width: "100%",
                        mt: 1,
                        mb: 2
                    }}
                >
                    <TextField
                        fullWidth
                        label="E-mail"
                        type="email"
                        variant="outlined"
                        value={tennant?.EmailUser || ''}
                        onChange={(e) => onChange('EmailUser', e.target.value)}
                    />
                    <TextField
                        fullWidth
                        label="Senha"
                        type="password"
                        variant="outlined"
                        value={tennant?.EmailPassword || ''}
                        onChange={(e) => onChange('EmailPassword', e.target.value)}
                    />
                </Box>

                <TextField
                    fullWidth
                    label="E-mail From"
                    type="email"
                    variant="outlined"
                    value={tennant?.EmailFrom || ''}
                    onChange={(e) => onChange('EmailFrom', e.target.value)}
                    sx={{ mb: 2 }}
                />
                
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        width: "100%",
                    }}
                >
                    <TextField
                        fullWidth
                        label="Host"
                        type="text"
                        variant="outlined"
                        value={tennant?.EmailHost || ''}
                        onChange={(e) => onChange('EmailHost', e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        width="40%"
                        label="Porta"
                        type="number"
                        variant="outlined"
                        value={tennant?.EmailPort || ''}
                        onChange={(e) => onChange('EmailPort', e.target.value)}
                        sx={{ mb: 2 }}
                    />

                    <FormControlLabel 
                        label="Secure" 
                        labelPlacement='start' 
                        sx={{ 
                            width: "50%", pb: 2 
                        }} 
                        control={
                            <Checkbox 
                                checked={(tennant?.EmailSecure ?? false)} 
                                onChange={(e) => onChange('EmailSecure', (e?.target?.checked ?? false))} 
                            />
                        } 
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <MDButton variant="contained" color="success" size="medium" onClick={onConfirm}>
                    Salvar
                </MDButton>
                <MDButton variant="contained" color="info" size="medium" onClick={onCancel}>
                    Cancelar
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}